import { useState } from "react"
import close from '../../res/images/close.png';
import { FileIcon, defaultStyles } from "react-file-icon"

function Obavestenje({ data }) {
    const [popup, setPopup] = useState(false)

    const togglePopup = () => setPopup(!popup)

    if (popup) {
        document.body.classList.add('active-modal')
    }
    else {
        document.body.classList.remove('active-modal')
    }


    return <>
        <div className="obavestenje">
            <section className="gore">
                <a onClick={togglePopup}>{data['naslov']}</a>
            </section>
            <section className="dole">
                <div className="tri-tacke" onClick={togglePopup}>
                    <p>
                        Прочитај више...
                    </p>
                </div>
                <p>{data['datum']}</p>
            </section>
        </div>
        {popup &&
            <>
                <div className="modal">
                    <div className="overlay" onClick={togglePopup}>
                    </div>
                    <div className="content">
                        <div className="close" onClick={togglePopup}>
                            <img src={close}></img>
                        </div>
                        <h1>{data['naslov']}</h1>
                        <div className="hl"></div>
                        <div className='tekst' dangerouslySetInnerHTML={{ __html: data['tekst'] }}></div>
                        {data['fajlovi'].length > 0 &&
                            <>
                                <h1 className="fajlovi-tekst">Приложена документа : </h1>
                                <ul className="fajlovi">
                                    {data['fajlovi'].map((fajl) => {
                                        return <>
                                            <li className="fajl">
                                                <div className="slikaFajla">
                                                    <FileIcon extension={fajl['ext']} {...defaultStyles[`${fajl['ext']}`]} />
                                                </div>
                                                <a href={fajl['link']} target="_blank">{fajl['naslov']}</a>
                                            </li>
                                        </>
                                    })}
                                </ul>
                            </>}

                    </div>
                </div>
            </>
        }
    </>
}

export default Obavestenje